import React, { Component } from 'react'

class LoaderSmall extends Component {
    constructor(props) {
        super(props)
    
    }
    
    render() {
        return (
            <div>
                {
                    (this.props.isLoaded) ? (
                        null
                    ) : (
                            <i className="fa fa-spinner fa-spin"></i>
                        )
                }
            </div>
        )
    }
}

export default LoaderSmall
